import {inject, ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import {useDialog, useUser} from "@/Composables";
export default function useCutSheet() {
    const route = inject('route');
    const { user} = useUser();
    const isSending = ref(false);
    const isDownloading = ref(false);

    const form = useForm({
        email: user.value.email ?? null,
    });

    const emailCutSheet = (slug) => {
        isSending.value = true;
        if (!form.email) {
            return;
        }

        form.post(
            route("web.catalog.products.cut-sheet.email", {
                slug: slug,
            }),
            {
                preserveState: true,
                only: ['referer', 'flash'],
                onFinish: () => {
                    isSending.value = false;
                    useDialog().forceClose();
                }
            }
        );
    };

    const downloadCutSheet = async (slug) => {
        isDownloading.value = true;
        window.location = route("web.catalog.products.cut-sheet.download", {
            slug: slug,
        });
        setTimeout(() => {
            isDownloading.value = false;
            useDialog().forceClose();
        },600)
    };

    return {
        emailCutSheet,
        downloadCutSheet,
        form,
        isSending,
        isDownloading,
    }
}
